import { PARTICIPANT_UPDATED } from '../../../react/features/base/participants/actionTypes';
import { getParticipantById } from '../../../react/features/base/participants/functions';
import logger from '../../../react/features/remote-control/logger';
import {
    DISCO_WILDIX_REMOTE_CONTROL_FEATURE
} from '../../components/wildix-remote-control/constants';

export function updateRemoteParticipantFromPresence(jitsiParticipant) {
    return (dispatch, getState) => {
        if (!jitsiParticipant) {
            return;
        }

        const id = jitsiParticipant.getId();

        jitsiParticipant.getFeatures()
            .then(features => {
                const supportsWildixRemoteControl = features.has(DISCO_WILDIX_REMOTE_CONTROL_FEATURE);

                const participant = getParticipantById(getState(), id);

                if (!participant || participant.local) {
                    return;
                }

                if (participant?.supportsWildixRemoteControl !== supportsWildixRemoteControl) {
                    return dispatch({
                        type: PARTICIPANT_UPDATED,
                        participant: {
                            id,
                            supportsWildixRemoteControl
                        }
                    });
                }
            })
            .catch(error => {
                logger.warn(`Failed to get participant features for ${id}!`, error);
            });
    };
}
